import { Component, Input } from '@angular/core';
import { LinkType } from '../link/link.interface';
import { LinkInfo } from './links-group.interface';

@Component({
  selector: 'vm-links-group',
  templateUrl: './links-group.component.html',
  styleUrls: ['./links-group.component.scss'],
})
export class LinksGroupComponent {
  @Input() links: Array<LinkInfo>;
  @Input() title: string;
  linkType = LinkType.STANDALONE;
}
